import script from "./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue?vue&type=script&setup=true&lang=js"

import "./information.vue?vue&type=style&index=0&id=3de7cfa9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de7cfa9"]])

export default __exports__